/**
 * SENSHI ACCESSORY (Strap / Belt) — VARIANT MODEL (PDP)
 * Colour (+ Size) are real options. Selecting resolves the matching variant,
 * sets the form's variant id, swaps the gallery photo to the variant image, and
 * optionally adds an Embroidery line item. Opens the theme cart drawer after add.
 */
import Cart from 'cart-store';

(function () {
  'use strict';

  var configEl = document.getElementById('senshi-accessory-variants-config');
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { console.error('[Senshi] config parse error', e); return; }
  if (!config || !config.isSenshiAccessory) return;

  var variants = config.variants || [];
  var hasSize = !!config.hasSize;

  var root = document.getElementById('senshi-accessory-variants');
  var form = document.querySelector('.js-product-form');
  if (!root || !form) return;

  var colourSwatches = root.querySelectorAll('#senshi-colour-swatches .senshi-swatch');
  var sizeButtons = root.querySelectorAll('#senshi-size-options .senshi-size-btn');
  var colourSelected = document.getElementById('senshi-colour-selected');

  var ENGLISH_ONLY = /^[A-Za-z0-9 \-'.]*$/;
  function stripNonEnglish(str) { return str.replace(/[^A-Za-z0-9 \-'.]/g, ''); }

  var currentVariant = null;

  function selectedColour() {
    var r = root.querySelector('input[name="senshi-colour"]:checked');
    return r ? r.value : null;
  }
  function selectedSize() {
    if (!hasSize) return '';
    var r = root.querySelector('input[name="senshi-size"]:checked');
    return r ? r.value : null;
  }

  function resolveVariant() {
    var c = selectedColour();
    var s = selectedSize();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.colour === c && (v.size === s || !v.size)) return v;
    }
    return null;
  }

  // ── Gallery photo swap ──
  function mediaIdFor(variant) {
    if (variant && variant.mediaId) return variant.mediaId;
    // fall back to any variant of the same colour that has a media id
    if (variant) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].colour === variant.colour && variants[i].mediaId) return variants[i].mediaId;
      }
    }
    return null;
  }
  function swapGallery(variant) {
    var mediaId = mediaIdFor(variant);
    if (!mediaId) return;
    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.goToSlide === 'function') gallery.goToSlide(mediaId);
  }

  // ── Price ──
  var priceEl = document.querySelector('.product-single__box__block--price .price__number--sale .money')
             || document.querySelector('.product-single__box__block--price .money');
  var priceCurrencySuffix = '';
  if (priceEl) {
    var m = priceEl.textContent.match(/([\d,]+(?:\.\d+)?)/);
    if (m) priceCurrencySuffix = priceEl.textContent.replace(m[1], '').replace(/^\s*\$/, '').trim();
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + (priceCurrencySuffix ? ' ' + priceCurrencySuffix : '');
  }
  function updatePrice() {
    if (!priceEl) return;
    var base = currentVariant ? currentVariant.price : 0;
    var addOn = (embToggle && embToggle.checked) ? (config.embroideryPrice || 0) : 0;
    priceEl.textContent = formatMoney(base + addOn);
  }

  // ── Availability ──
  function colourHasStock(colour) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].colour === colour && variants[i].available) return true;
    }
    return false;
  }
  function updateColourAvailability() {
    colourSwatches.forEach(function (sw) {
      var available = colourHasStock(sw.dataset.colour);
      sw.classList.toggle('senshi-swatch--soldout', !available);
      sw.dataset.available = available ? 'true' : 'false';
    });
  }
  function updateSizeAvailability() {
    if (!hasSize) return;
    var c = selectedColour();
    sizeButtons.forEach(function (btn) {
      var size = btn.dataset.size;
      var available = false;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].colour === c && variants[i].size === size && variants[i].available) { available = true; break; }
      }
      btn.classList.toggle('senshi-size-btn--soldout', !available);
      btn.dataset.available = available ? 'true' : 'false';
    });
  }

  // ── Strap preview (photo of selected colour) + embroidery text overlay ──
  var strapImages = {};
  var siEl = root.querySelector('#senshi-strap-images');
  if (siEl) { try { strapImages = JSON.parse(siEl.textContent) || {}; } catch (e) { strapImages = {}; } }
  var strapTextStyles = {};
  var stsEl = root.querySelector('#senshi-strap-text-style');
  if (stsEl) { try { strapTextStyles = JSON.parse(stsEl.textContent) || {}; } catch (e) { strapTextStyles = {}; } }
  var strapPreview = root.querySelector('[data-senshi-strap-preview]');
  var strapPreviewImg = root.querySelector('[data-senshi-strap-preview-img]');
  var strapPreviewText = root.querySelector('[data-senshi-strap-preview-text]');
  var STRAP_TEXT_PLACEHOLDER = 'JOHN';

  // ── Embroidery text colour (thread) — overrides the auto strap colour in the preview ──
  var threadGroup = root.querySelector('[data-thread-group]');
  function selectedThreadName() {
    var r = threadGroup && threadGroup.querySelector('input[type="radio"]:checked');
    return r ? r.value : '';
  }
  function selectedThreadHex() {
    var r = threadGroup && threadGroup.querySelector('input[type="radio"]:checked');
    var sw = r && r.closest('.senshi-thread-swatch');
    return sw ? (sw.getAttribute('data-hex') || '') : '';
  }
  if (threadGroup) {
    threadGroup.querySelectorAll('.senshi-thread-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        threadGroup.querySelectorAll('.senshi-thread-swatch').forEach(function (s) { s.classList.remove('senshi-thread-swatch--active'); });
        sw.classList.add('senshi-thread-swatch--active');
        var r = sw.querySelector('input[type="radio"]'); if (r) r.checked = true;
        updateStrapText();
      });
    });
  }

  function applyStrapTextStyle(colour) {
    if (!strapPreviewText) return;
    var st = (colour && strapTextStyles[colour]) || {};
    strapPreviewText.style.color = selectedThreadHex() || st.color || '';
    strapPreviewText.style.right = st.right || '';
    strapPreviewText.style.top = st.top || '';
    strapPreviewText.style.fontSize = st.fontSize || '';
  }
  function updateStrapText() {
    if (!strapPreviewText) return;
    var on = embToggle && embToggle.checked;
    var typed = embTextInput ? embTextInput.value : '';
    var shown = on ? (typed || STRAP_TEXT_PLACEHOLDER) : '';
    strapPreviewText.textContent = shown;
    strapPreviewText.setAttribute('data-text', shown);
    strapPreviewText.setAttribute('data-thread', selectedThreadName() || '');
    applyStrapTextStyle(selectedColour());
  }
  function updateStrapPreview() {
    if (!strapPreview || !strapPreviewImg) return;
    var on = embToggle && embToggle.checked;
    var colour = selectedColour();
    var src = colour ? strapImages[colour] : null;
    if (on && src) {
      strapPreviewImg.src = src;
      strapPreviewImg.alt = (colour || '') + ' strap';
      strapPreview.hidden = false;
    } else {
      strapPreview.hidden = true;
    }
    updateStrapText();
  }

  // ── Central update ──
  function updateSelection() {
    currentVariant = resolveVariant();
    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput && currentVariant) variantInput.value = currentVariant.id;
    if (currentVariant) swapGallery(currentVariant);
    if (colourSelected) colourSelected.textContent = selectedColour() || '';
    updatePrice();
    updateStrapPreview();
  }

  // ── Colour swatches ──
  colourSwatches.forEach(function (sw) {
    sw.addEventListener('click', function (e) {
      if (sw.dataset.available === 'false') { e.preventDefault(); return; }
      e.preventDefault();
      colourSwatches.forEach(function (s) { s.classList.remove('senshi-swatch--active'); });
      sw.classList.add('senshi-swatch--active');
      var r = sw.querySelector('input[type="radio"]');
      if (r) r.checked = true;
      updateSizeAvailability();
      updateSelection();
    });
  });

  // ── Size buttons ──
  sizeButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.dataset.available === 'false') { e.preventDefault(); return; }
      e.preventDefault();
      sizeButtons.forEach(function (b) { b.classList.remove('senshi-size-btn--active'); });
      btn.classList.add('senshi-size-btn--active');
      var r = btn.querySelector('input[type="radio"]');
      if (r) r.checked = true;
      updateSelection();
    });
  });

  // ── Embroidery ──
  var embToggle = document.getElementById('senshi-embroidery-toggle');
  var embFields = document.getElementById('senshi-embroidery-fields');
  var embTextInput = document.getElementById('senshi-embroidery-text');
  var charCurrent = document.getElementById('senshi-char-current');

  function showEmbError(msg) { var el = document.getElementById('senshi-embroidery-error'); if (el) { el.textContent = msg; el.style.display = 'block'; } }
  function clearEmbError() { var el = document.getElementById('senshi-embroidery-error'); if (el) el.style.display = 'none'; }

  if (embToggle && embFields) {
    embToggle.addEventListener('change', function () {
      embFields.style.display = embToggle.checked ? 'block' : 'none';
      if (!embToggle.checked && embTextInput) {
        embTextInput.value = '';
        if (charCurrent) charCurrent.textContent = '0';
        clearEmbError();
      }
      if (embToggle.checked && embTextInput) embTextInput.focus();
      updatePrice();
      updateStrapPreview();
    });
  }

  if (embTextInput) {
    embTextInput.addEventListener('input', function () {
      var cursor = embTextInput.selectionStart;
      var original = embTextInput.value;
      var cleaned = stripNonEnglish(original);
      if (cleaned !== original) {
        embTextInput.value = cleaned;
        var removed = original.length - cleaned.length;
        embTextInput.setSelectionRange(cursor - removed, cursor - removed);
        showEmbError('English characters only (A-Z, 0-9, spaces and basic punctuation).');
      } else {
        clearEmbError();
      }
      if (charCurrent) charCurrent.textContent = embTextInput.value.length;
      updateStrapText();
    });
    embTextInput.addEventListener('paste', function (e) {
      e.preventDefault();
      var pasted = (e.clipboardData || window.clipboardData).getData('text');
      var cleaned = stripNonEnglish(pasted).substring(0, 10);
      var start = embTextInput.selectionStart;
      var end = embTextInput.selectionEnd;
      var current = embTextInput.value;
      var newVal = (current.substring(0, start) + cleaned + current.substring(end)).substring(0, 10);
      embTextInput.value = newVal;
      if (charCurrent) charCurrent.textContent = newVal.length;
      if (pasted !== cleaned) showEmbError('Non-English characters were removed from your paste.');
      else clearEmbError();
    });
  }

  // ── Intercept add-to-cart ──
  form.addEventListener('submit', function (e) {
    if (!document.getElementById('senshi-accessory-variants')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    handleAddToCart();
  }, true);

  var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      if (!document.getElementById('senshi-accessory-variants')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      handleAddToCart();
    }, true);
  }

  async function handleAddToCart() {
    if (!currentVariant) currentVariant = resolveVariant();
    if (!currentVariant) { showError('Please choose your options.'); return; }
    if (!currentVariant.available) { showError('This combination is sold out. Please pick another.'); return; }

    var embEnabled = embToggle ? embToggle.checked : false;
    var embText = embTextInput ? embTextInput.value.trim() : '';
    if (embEnabled && !embText) { showError('Please enter your embroidery text.'); if (embTextInput) embTextInput.focus(); return; }
    if (embEnabled && embText.length > 10) { showError('Embroidery text must be 10 characters or less.'); if (embTextInput) embTextInput.focus(); return; }
    if (embEnabled && !ENGLISH_ONLY.test(embText)) { showError('Embroidery text must use English characters only.'); if (embTextInput) embTextInput.focus(); return; }

    var items = [];
    var bagItem = { id: currentVariant.id, quantity: 1, properties: {} };
    if (embEnabled && embText) bagItem.properties['Embroidery'] = embText;
    if (currentVariant.image) bagItem.properties['_bag_image'] = currentVariant.image;
    items.push(bagItem);

    if (embEnabled && embText && config.embroideryVariantId) {
      var embProps = { 'Embroidery Text': embText };
      var threadName = selectedThreadName();
      if (threadName) embProps['Embroidery Colour'] = threadName;
      var embVariantId = (config.embroideryVariants && config.embroideryVariants[selectedColour()]) || config.embroideryVariantId;
      items.push({ id: embVariantId, quantity: 1, properties: embProps });
    }

    setLoading(true);
    try {
      await Cart.add(items);
      openCartDrawer();
    } catch (err) {
      showError(err.message || 'Error adding to cart. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  function openCartDrawer() {
    var cartModal = document.querySelector('.modal--cart, .popup--cart-notification');
    if (!cartModal) { window.location.href = '/cart'; return; }
    if (!cartModal.shown) cartModal.open();
    else if (cartModal.interval) { cartModal.interval.reset(); cartModal.interval.start(); }
  }

  function setLoading(loading) {
    var btn = form.querySelector('[type="submit"], button[name="add"], .js-add-to-cart');
    if (!btn) return;
    if (loading) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('btn--loading', 'is-loading'); }
    else { btn.removeAttribute('disabled'); btn.classList.remove('btn--loading', 'is-loading'); }
  }

  function showError(msg) {
    var el = form.querySelector('.product-form__error, .js-form-error');
    if (el) { el.textContent = msg; el.style.display = 'block'; setTimeout(function () { el.style.display = 'none'; }, 5000); return; }
    alert(msg);
  }

  // ── Initial paint ──
  updateColourAvailability();
  updateSizeAvailability();
  updateSelection();
})();
